import React, { useState } from 'react';
import { ContractDataWithLinks } from 'cpie-common';
import { LicensePlate } from '../../license-plate';
import { Card } from '@vwfs-bronson/bronson-react';
import { ContractHeader } from '@cp-shared-15/frontend-ui';
import { useTranslation } from 'react-i18next';
import { ContractEndOptionsView } from './enums';
import { ErrorNotification } from '../../notifications/error/ErrorNotification';
import { ContractEndOptionsStep } from './ContractEndOptionsStep';

export const ContractEndOptionsUi: React.FC<{
    contract?: ContractDataWithLinks;
}> = ({ contract }) => {
    const { t } = useTranslation('contract-end-options');
    const [contractEndOptionsView, setContractEndOptionsView] = useState(ContractEndOptionsView.OPTIONS_OVERVIEW);

    const { licensePlate, contractNumber = '', brand, model = '' } = contract ?? {};

    const carInformation = `${!!brand ? `${brand} ` : ''}${model ?? ''}`;

    if (!contract) {
        return <ErrorNotification testId={'no-connection-error'} />;
    }

    return (
        <ContractEndOptionsStep
            contractEndOptionsView={contractEndOptionsView}
            setContractEndOptionsView={setContractEndOptionsView}
            contractNumber={contractNumber ?? ''}
            brand={brand}
            header={
                <Card title="">
                    <ContractHeader
                        carInformation={carInformation}
                        contractCategory={t('product-type')}
                        contractNumber={contractNumber}
                        contractIdentifier={<LicensePlate registrationNumber={licensePlate} />}
                    />
                </Card>
            }
        />
    );
};
